import { useCallback, useEffect, useRef, useState } from "react";
import { PropagateLoader } from "react-spinners";
import CardTables from "../../../atoms/CardTables";
import TableCasos from "../../../organisms/DF/casos/TableCasos";
import DFHeader from "../../../organisms/clientes/empresas/headers/df/DFHeader";
import { GET_CASOS_BY_ENTERPRISE } from "../../../../api/apiCasos";
import { GET_ENTERPRISE_BY_ID } from "../../../../api/apiEmpresas";
import { useSession } from "../../../../context/SessionContext";
import { toast } from "react-toastify";

const DFTemplate = ({ id }) => {
    const { user } = useSession();
    const [casos, setCasos] = useState([]);
    const [empresa, setEmpresa] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const idRef = useRef(id);

    const getCasos = useCallback ( async () => {
        const currentId = idRef.current;
        if (!currentId) return;

        setLoadingData(true);

        try {
            const casosData = await GET_CASOS_BY_ENTERPRISE(currentId);
            const sortedCasos = [...casosData].sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            });
            setCasos(sortedCasos);
        } catch (error) {
            console.error(error);
            toast.error("Error al cargar los casos");
        } finally {
            setLoadingData(false);
        }
    },[]);

    useEffect(() => {
        idRef.current = id;
    }, [id]);

    useEffect(() => {
        if (!id) return;
        getCasos();
    }, [id, getCasos]);

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const empresaData = await GET_ENTERPRISE_BY_ID(id);
                setEmpresa(empresaData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [id]);

    if (!id) return <div className="flex h-screen w-full justify-center items-center"> Error: recargar la pagina </div>;
    if (loading) return <div className="flex h-screen w-full justify-center items-center"> <PropagateLoader color="red"/> </div>;

    return (
        <div className="space-y-2">
            <DFHeader empresa={empresa} refetch={getCasos} user={user} />
            <CardTables>
                <TableCasos data={casos} refetch={getCasos} loading={loadingData} user={user} />
            </CardTables>
        </div>
    );
};

export default DFTemplate;